import { OptionTypeWithCode } from '../../Select';

export enum ActionOptions {
  AddNewTag = 'AddNewTag',
  EnableEditMode = 'EnableEditMode'
}

export type TagOption = Pick<OptionTypeWithCode<string>, 'value' | 'labelInEditMode' | 'label'>;
